import { AnalyticsPlatforms, useAnalytics } from '@dni-analysis'
import { useBeforeunload } from '@dni-react-hooks/use-beforeunload'
import { Button } from '@pets-ui/Button/Button'
import { ArrowLeftSmall } from '@pets-ui/icons'
import { Input } from '@pets-ui/Input/Input'
import * as stylex from '@stylexjs/stylex'
import { isEmail } from '@utils'
import Cookies from 'js-cookie'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Service } from '../Service'
import { CardTitleWithIcon } from './CardTitleWithIcon'
import { LoginStep } from './types'
import { useContextLogin } from './useContextLogin'

const styles = stylex.create({
  confirmButton: {
    marginTop: '20px',
  },
})

export function LoginEmail() {
  const { t } = useTranslation()
  const { sendEvent } = useAnalytics({ defaultPlatforms: [AnalyticsPlatforms.GA4] })
  const { setStep, email, setEmail, setPhone, countryCode, isEmailDomainRejected, setIsEmailDomainRejected } = useContextLogin()
  const [emailError, setEmailError] = useState('')
  const displayedEmailError = isEmailDomainRejected ? String(t('error.otpEmailProviderNotSupported')) : emailError

  const handleClickBack = () => {
    sendEvent({ eventName: 'Email return', eventParams: { event_category: 'Email login' } })
    setStep(LoginStep.LOGIN)
  }

  const handleClickConfirm = () => {
    /* Enter 鍵不受按鈕 disabled 約束，這裡要再擋一次 */
    if (isEmailDomainRejected || !email || !countryCode) return

    if (!isEmail(email)) {
      setEmailError(String(t('error.incorrectEmailFormat')))
      sendEvent({ eventName: 'Email verify', eventParams: { event_category: 'Email login', email_login_verify: false } })
      sendEvent({ eventName: 'Email login error', eventParams: { event_category: 'Email login', email_login_error: 'incorrect format' } })
      return
    }
    Cookies.set('account', email)
    Cookies.set('country_code', countryCode)
    sendEvent({ eventName: 'Email verify', eventParams: { event_category: 'Email login', email_login_verify: true } })
    setStep(LoginStep.VALIDATE_EMAIL)
    setEmailError('')
  }

  useEffect(() => {
    setPhone('')
  }, [setPhone])

  useBeforeunload(() => {
    sendEvent({ eventName: 'Email drop', eventParams: { event_category: 'Email login' } })
  })

  return (
    <>
      <CardTitleWithIcon
        title={t('login.emailLogin')}
        leftIcon={<ArrowLeftSmall />}
        onClickLeft={handleClickBack}
      />
      <Input
        label={t('login.email')}
        fullWidth
        placeholder={String(t('login.pleaseEnter'))}
        name="email"
        value={email}
        onChange={(e) => {
          setEmail(e.target.value)
          setIsEmailDomainRejected(false)
        }}
        error={!!displayedEmailError}
        helpText={displayedEmailError}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleClickConfirm()
          }
        }}
      />
      <Button
        fullWidth
        disabled={!email?.trim() || isEmailDomainRejected}
        rootStyle={styles.confirmButton}
        onClick={handleClickConfirm}
      >
        {t('button.confirm')}
      </Button>
      <Service />
    </>
  )
}
